import Title from "../components/TheTitle.vue";
import { getPointTypesMaster, searchPointHistory } from "../api";
import { Validation } from "../utils/validation";
import { FormatDate } from "../utils/formatDate";
import { Authorize } from "../utils/authorize";
export default {
    name: "pointTransactionHistory",
    data() {
        return {
            infoPage: 1,
            pageSize: 100,
            tableInfo: [],
            pointType: [],
            form: {
                pointType: "",
                historyType: "",
                note: "",
                customerId: "",
                tradedAtFrom: "",
                tradedAtTo: "",
                historyDateFrom: "",
                historyDateTo: "",
                pointMin: "",
                pointMax: "",
                brandStore: "",
                billNo: "",
                expirationDateFrom: "",
                expirationDateTo: "",
                targetTradingAmountFrom: "",
                targetTradingAmountTo: "",
            },
        };
    },
    components: {
        Title,
    },
    computed: {
        infoTotalPages() {
            return Math.max(1, Math.ceil(this.tableInfo.length / this.pageSize));
        },
        pagedInfo() {
            const start = (this.infoPage - 1) * this.pageSize;
            return this.tableInfo.slice(start, start + this.pageSize);
        },
    },
    methods: {
        setInfoPage(p) {
            if (p < 1)
                p = 1;
            if (p > this.infoTotalPages)
                p = this.infoTotalPages;
            this.infoPage = p;
        },
        formatDate(value) {
            return FormatDate.withoutTime(value);
        },
        exportCsv() {
            if (!this.tableInfo.length) {
                this.$store.commit("setMessages", ["出力対象のデータが存在しません。"]);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
                return;
            }
            // 1) ヘッダを作成
            const header = [
                "ポイント種別",
                "付与/利用",
                "備考",
                "顧客ID",
                "対象取引入金日",
                "付与・利用日",
                "付与・利用ポイント",
                "店舗（ブランド）",
                "有効期限",
                "対象取引金額",
                "付与率",
                "請求書番号",
            ];
            // 2) tableInfo から値を取得（空文字や null は空文字に）
            const rows = this.tableInfo.map((t) => [
                t.point_type,
                t.history_type === 0 ? "付与" : "利用",
                t.note,
                t.crm_customer_id,
                this.formatDate(t.traded_at),
                this.formatDate(t.history_date),
                t.points,
                t.brand || t.store ? t.brand + t.store : "",
                this.formatDate(t.expiration_date),
                t.target_trading_amount ?? "",
                t.grant_rate != null ? (t.grant_rate * 100).toFixed(2) + "%" : "",
                t.bill_no ?? "",
            ]);
            // 3) CSV を作る
            const escapeCsv = (value) => {
                if (value == null)
                    return "";
                const v = String(value);
                return v;
            };
            const lines = [];
            lines.push(header.map(escapeCsv).join(","));
            for (const r of rows) {
                lines.push(r.map(escapeCsv).join(","));
            }
            let csvContent = lines.join("\r\n");
            // 4) Excel で文字化けしにくくするために UTF-8 BOM を付与（不要なら削除）
            const bom = "\uFEFF";
            const blob = new Blob([bom + csvContent], {
                type: "text/csv;charset=utf-8;",
            });
            // 5) ダウンロード処理
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            // ファイル名（任意）
            a.download = "ポイント取引履歴_検索結果.csv";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        },
        onClear() {
            this.form = {
                pointType: "",
                historyType: "",
                note: "",
                customerId: "",
                tradedAtFrom: "",
                tradedAtTo: "",
                historyDateFrom: "",
                historyDateTo: "",
                pointMin: "",
                pointMax: "",
                brandStore: "",
                billNo: "",
                expirationDateFrom: "",
                expirationDateTo: "",
                targetTradingAmountFrom: "",
                targetTradingAmountTo: "",
            };
        },
        async onSearch() {
            const params = {
                point_bulk_grant_history_id: "",
                point_type: (this.form.pointType || null),
                history_type: (this.form.historyType || null),
                note: (this.form.note || null),
                crm_customer_id: (this.form.customerId || null),
                traded_at_from: (this.form.tradedAtFrom || null),
                traded_at_to: (this.form.tradedAtTo || null),
                history_date_from: (this.form.historyDateFrom || null),
                history_date_to: (this.form.historyDateTo || null),
                points_min: (this.form.pointMin || null),
                points_max: (this.form.pointMax || null),
                brandStore: (this.form.brandStore || null),
                bill_no: (this.form.billNo || null),
                expiration_date_from: (this.form.expirationDateFrom || null),
                expiration_date_to: (this.form.expirationDateTo || null),
                target_trading_amount_from: (this.form.targetTradingAmountFrom ||
                    null),
                target_trading_amount_to: (this.form.targetTradingAmountTo ||
                    null),
            };
            const errorMessage = this.validate(params);
            if (errorMessage) {
                this.$store.commit("setMessages", errorMessage);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
                return;
            }
            const response = await searchPointHistory(params.point_bulk_grant_history_id, params.point_type, params.history_type, params.note, params.crm_customer_id, params.traded_at_from, params.traded_at_to, params.history_date_from, params.history_date_to, params.points_min, params.points_max, params.brandStore, params.bill_no, params.expiration_date_from, params.expiration_date_to, params.target_trading_amount_from, params.target_trading_amount_to);
            if (response.result?.code === 9) {
                this.$store.commit("setMessages", response.result.messages);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
            }
            else {
                this.tableInfo = response.data.results;
                this.infoPage = 1;
            }
        },
        validate(params) {
            // エラーメッセージを格納する配列
            const errors = [];
            // 桁数チェック
            errors.push(...Validation.digitsMax({
                key: "備考",
                value: params.note,
            }, 110));
            errors.push(...Validation.digitsMax({
                key: "顧客ID",
                value: params.crm_customer_id,
            }, 20));
            errors.push(...Validation.digitsMax({
                key: "付与/利用ポイントmin",
                value: params.points_min,
            }, 6));
            errors.push(...Validation.digitsMax({
                key: "付与/利用ポイントmax",
                value: params.points_max,
            }, 6));
            errors.push(...Validation.digitsMax({
                key: "店舗（ブランド）",
                value: params.brandStore,
            }, 80));
            errors.push(...Validation.digitsMax({
                key: "請求書番号",
                value: params.bill_no,
            }, 50));
            errors.push(...Validation.digitsMax({
                key: "対象取引金額From",
                value: params.target_trading_amount_from,
            }, 10));
            errors.push(...Validation.digitsMax({
                key: "対象取引金額To",
                value: params.target_trading_amount_to,
            }, 10));
            // 属性チェック
            if (params.crm_customer_id) {
                errors.push(...Validation.isInteger({
                    key: "顧客ID",
                    value: params.crm_customer_id,
                }));
            }
            if (params.points_min) {
                errors.push(...Validation.isInteger({
                    key: "付与/利用ポイントmin",
                    value: params.points_min,
                }));
            }
            if (params.points_max) {
                errors.push(...Validation.isInteger({
                    key: "付与/利用ポイントmax",
                    value: params.points_max,
                }));
            }
            if (params.target_trading_amount_from) {
                errors.push(...Validation.isInteger({
                    key: "対象取引金額From",
                    value: params.target_trading_amount_from,
                }));
            }
            if (params.target_trading_amount_to) {
                errors.push(...Validation.isInteger({
                    key: "対象取引金額To",
                    value: params.target_trading_amount_to,
                }));
            }
            // 相関チェック
            if (params.traded_at_from &&
                params.traded_at_to &&
                params.traded_at_from > params.traded_at_to) {
                errors.push("対象取引入金日のFromとToは、FromがToより小さくなるように入力してください。");
            }
            if (params.history_date_from &&
                params.history_date_to &&
                params.history_date_from > params.history_date_to) {
                errors.push("付与/利用日のFromとToは、FromがToより小さくなるように入力してください。");
            }
            if (params.points_min &&
                params.points_max &&
                Number(params.points_min) >= Number(params.points_max)) {
                errors.push("付与/利用ポイントの下限値と上限値は、下限値が上限値より小さくなるように入力してください。");
            }
            if (params.expiration_date_from &&
                params.expiration_date_to &&
                params.expiration_date_from > params.expiration_date_to) {
                errors.push("有効期限のFromとToは、FromがToより小さくなるように入力してください。");
            }
            if (params.target_trading_amount_from &&
                params.target_trading_amount_to &&
                Number(params.target_trading_amount_from) >=
                    Number(params.target_trading_amount_to)) {
                errors.push("対象取引金額の下限値と上限値は、下限値が上限値より小さくなるように入力してください。");
            }
            if (errors.length > 0) {
                return errors;
            }
            return "";
        },
    },
    async mounted() {
        if (await Authorize.isExpired(this)) {
            const response = await getPointTypesMaster();
            if (response.result?.code === 9) {
                this.$store.commit("setMessages", response.result.messages);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
            }
            else {
                this.pointType = response.data.results;
            }
        }
    },
};
